import { pick } from 'lodash';
import moment from 'moment';
import { Moment } from 'moment';

/**
 * Gets the scroll offset of the viewport in regards to the content, given a percentage.
 * @param scrollPercentage The percentage of the content scrolled.
 * @param contentHeight The total height of the content.
 * @param viewportHeight The height of the viewport into the content.
 * @returns The scroll offset (from the top) of the viewport.
 */
export const getViewportScrollOffset = (
  scrollPercentage: number,
  contentHeight: number,
  viewportHeight: number,
) => scrollPercentage * (contentHeight - viewportHeight);

/**
 * Uses `getBoundingClientRect()` to get the width/height of a potentially null element.
 * @param element The element to measure.
 * @returns The element's width/height.
 */
export const getElementDimensions = (element: HTMLDivElement | null) => {
  if (!element) return { width: 0, height: 0 };
  const clientRect = element.getBoundingClientRect();
  return pick(clientRect, ['width', 'height']);
};

/**
 * Gets a list of all the days in the given months. Used to find the month label to show
 * based on the scroll position of the viewport.
 * @param months Array of months.
 * @returns Array of all days in the given months.
 */
export const daysInMonths = (months: Moment[]): Moment[] =>
  months
    .map(month =>
      Array.from({ length: moment(month).daysInMonth() }, (_, i) =>
        moment(month).startOf('month').add(i, 'days'),
      ),
    )
    .flat();
